import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { NotificationModal } from '../../../common/modal/notification-modal.component';
import { TABLE_PAGINATION_KEY, DASHBOARD_LABEL, MODAL_CUSTOM_MESSAGE, Selected_Index, RECHARGE_INVENTORY_TYPE, UPLOAD_TYPES } from "../../../../constants/external-constants";

import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import "../recharging-inventory.css";
import RechargingCircuitDetailsView from "./circuit/recharging-circuit-details.component";
import RechargingEquipmentDetailsView from "./equipment/layout/recharging-equipment-details.component";
import RechargingOtcDetailsView from "./otc/layout/recharging-otc-details.component";
import { rechargingInventoryActions } from "../../../../store/external/recharge-reducer/recharging-inventory-reducer/recharging-inventory-reducer";
import { filterActions } from "../../../../store/external/filter-reducer/filter-reducer";
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
import { RechargeInventoryDetailsActions } from "../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer";

class RechargingInventory extends Component {
    constructor(props){
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.state = {
            viewDetailPage: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            displaySearch: false,
            headerTitle: "RechargingInventory",
            showConfirmationModal: false,
            createNewTitle: "",
            rechargeInventoryId: 0,
            statusActiveFilter: 0,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            selectedDetailsView: 0,
            isCreateNew: false,
            reapplySearchOnTabChange: false,
            showNotificationModal: false,
            isMapInventory: false,
            notificationModal: {
                title: "",
                messsage: ""
            },
            confirmationModal: {
                title: "",
                messsageBody: "",
            },
        }

    }

    componentDidMount() {
        this.props.applyRechargingInventoryStatusFilter(0);
        this.props.getRechargingInventory();
        this.getRechargeInventoryDetails();
        this.getMrcRecharge();
        this.getRechargeViaDummyInvoice();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.reapplySearchOnTabChange && this.props.rechargingInventory.isRechargingInventoryLoaded) {
            const {
                rechargingInventory: {
                    rechargingInventoryItems: {
                        Headers = {},
                        Columns: { Selected = [] }
                    }
                },
                setRechargingInventoryColSearchStr,
                getRechargingInventory
            } = this.props;

            if (!Headers || !Selected.length) return;

            let reApplied = false;

            Selected.forEach((colKey) => {
                const header = Headers[colKey];
                const previousSearchString = header?.searchString || "";

                if (previousSearchString.trim()) {
                    setRechargingInventoryColSearchStr(
                        { target: { value: previousSearchString } },
                        colKey
                    );
                    reApplied = true;
                }
            });

            if (reApplied) {
                getRechargingInventory(0);
            }

            this.setState({ reapplySearchOnTabChange: false });
        }
    }
    
    getRechargeViaDummyInvoice() {
        const { getRechargeViaDummyInvoiceDropdown } = this.props;
        getRechargeViaDummyInvoiceDropdown();
    }
    getMrcRecharge() {
        const { getMrcRechargeDropdown } = this.props;
        getMrcRechargeDropdown();
    }

    getRechargeInventoryDetails(){
        const { getRechargeInventoryDropdownList } = this.props
        getRechargeInventoryDropdownList();
    }

    componentWillUnmount() {
        this.props.setDefaultRechargingInventory();
    }

    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    handleCreateNewAction = (index) => {
        const { confirmationModal } = this.state;
        this.setState({
            showConfirmationModal: true,
            selectedDetailsView: index,
            isCreateNew: true,
            isMapInventory: false
        })
        switch(index) {
            case parseInt(Selected_Index.i_One):
                this.setState({
                    confirmationModal: {
                        ...confirmationModal,
                        title: "Add New",
                        messageBody: MODAL_CUSTOM_MESSAGE.create_new_recharging_circuit
                    }
                });
                break;
            case parseInt(Selected_Index.i_Two):
                this.setState({
                    confirmationModal: {
                        ...confirmationModal,
                        title: "Add New",
                        messageBody: MODAL_CUSTOM_MESSAGE.create_new_recharging_equipment
                    }
                });
                break;
            case parseInt(Selected_Index.i_Three):
                this.setState({
                    confirmationModal: {
                        ...confirmationModal,
                        title: "Add New",
                        messageBody: MODAL_CUSTOM_MESSAGE.create_new_recharging_otc
                    }
                });
                break;
            default:
                break;
        }
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState((prevState) => {
                const { selectedDetailsView } = prevState; // or use this.props if it's coming from props

                let headerTitle = "";
                if (selectedDetailsView === 1) {
                    headerTitle = "circuit_recharging_details";
                } else if (selectedDetailsView === 2) {
                    headerTitle = "equipment_recharging_details";
                } else if (selectedDetailsView === 3) {
                    headerTitle = "otc_recharging_details";
                }else{
                    headerTitle = "RechargingInventory";
                }

                this.props.setRechargeInventoryType(selectedDetailsView);

               return {viewDetailPage: true,
                showConfirmationModal: false,
                headerTitle
               }
            });
        } else {
            this.setState({ showConfirmationModal: false, selectedDetailsView: 0 })
        }

    }

    resizePage = (value) => {
        const { getRechargingInventory, resizeRechargingInventoryPage } = this.props;
        resizeRechargingInventoryPage(value);
        getRechargingInventory();
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractRechargingInventory();
        }
    };

    applyFilter = (isApply) => {
        const { getRechargingInventory, applyRechargingInventoryFilter } = this.props;
        applyRechargingInventoryFilter(isApply);
        getRechargingInventory(0);
    }

    handleCloseDetailsPage = async () => {
        this.handleSelectedIndex(this.state.contentIndex)
        this.setState({
            viewDetailPage: false,
            headerTitle: "RechargingInventory",
            activeTab: this.state.contentIndex,
            rechargeInventoryId: 0,
            selectedDetailsView: 0,
            isCreateNew: false
        });
        this.props.setRechargingInventoryLoading(false);
        await this.props.getRechargingInventory();
        this.props.setRechargingInventoryLoading(true);
    }

    statusActiveFilter = (statusActiveFilter) => {
        const { getRechargingInventory, applyRechargingInventoryStatusFilter } = this.props;
        applyRechargingInventoryStatusFilter(statusActiveFilter);
        getRechargingInventory(0);
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    handleSelectedIndex = (index) => {
        const parsedIndex = parseInt(index);
        const {
            applyRechargingInventoryTabFilter,
            resetFilter,
            getRechargingInventory,
            setRechargingInventoryColSearchStr,
            rechargingInventory: {
                rechargingInventoryItems: { Headers = {} }
            }
        } = this.props;

        if (this.state.contentIndex !== parsedIndex) {

            resetFilter();

            applyRechargingInventoryTabFilter(parsedIndex || 0);
            this.applyFilter(false)

            const {
                InventoryDateStr,
                InstallDateStr,
                DeliveryDateStr,
                ActivationDateStr,
            } = Headers;

            const inventoryDateSearchString =
                InventoryDateStr?.searchString ||
                InstallDateStr?.searchString ||
                DeliveryDateStr?.searchString ||
                ActivationDateStr?.searchString ||
                "";

            const updateColSearch = (val, key) => {
                setRechargingInventoryColSearchStr({ target: { value: val } }, key);
            };

            // Update date filters based on selected tab
            if (parsedIndex === parseInt(Selected_Index.i_One)) {
                updateColSearch("", "DeliveryDateStr");
                updateColSearch("", "ActivationDateStr");
                updateColSearch(inventoryDateSearchString, "InstallDateStr");
            } else if (parsedIndex === parseInt(Selected_Index.i_Two)) {
                updateColSearch("", "InstallDateStr");
                updateColSearch("", "ActivationDateStr");
                updateColSearch(inventoryDateSearchString, "DeliveryDateStr");
            } else if (parsedIndex === parseInt(Selected_Index.i_Three)) {
                updateColSearch("", "InstallDateStr");
                updateColSearch("", "DeliveryDateStr");
                updateColSearch(inventoryDateSearchString, "ActivationDateStr");
            }

            this.setState(
                {
                    contentIndex: parsedIndex,
                    reapplySearchOnTabChange: true
                },
                () => {
                    getRechargingInventory(0);
                }
            );
        }
    };
    handleRowClick = (data) => {
        this.setState(() => {

            let headerTitle = "";
            if (data.RechargingInventoryTypeID === RECHARGE_INVENTORY_TYPE["Circuit"].id) {
                headerTitle = "circuit_recharging_details";
            } else if (data.RechargingInventoryTypeID === RECHARGE_INVENTORY_TYPE["Equipment"].id) {
                headerTitle = "equipment_recharging_details";
            } else if (data.RechargingInventoryTypeID === RECHARGE_INVENTORY_TYPE["OTC"].id) {
                headerTitle = "otc_recharging_details";
            } else {
                headerTitle = "RechargingInventory";
            }

            return {
                viewDetailPage: true,
                showConfirmationModal: false,
                headerTitle,
                rechargeInventoryId: data.RechargingInventoryID,
                selectedDetailsView: data.RechargingInventoryTypeID
            }
        });

        console.log(data);
        // this.state.contentIndex - identifier of active tab
    }

    handleMapInventoryAction = () => {
        const { confirmationModal } = this.state;
        this.setState({
            confirmationModal: {
                ...confirmationModal,
                title: "Map Inventory",
                messageBody: MODAL_CUSTOM_MESSAGE.mapping_confirmation
            },
            showConfirmationModal: true,
            isMapInventory: true
        });
    };

    handleMapInventory(buttonType) {
        const { notificationModal } = this.state;
        const { mapRechargingInventory } = this.props;
        if (buttonType === "ok") {
            this.setState({
                notificationModal: {
                    ...notificationModal,
                    title: "Notification",
                    message: MODAL_CUSTOM_MESSAGE.mapping_notification
                },
                showConfirmationModal: false,
                showNotificationModal: true,
                isMapInventory: false
            });
            mapRechargingInventory(UPLOAD_TYPES.RechargeMappingInventory);
        } else {
            this.setState({ showConfirmationModal: false, showNotificationModal: false })
        }
    }

    render(){
        const { rechargingInventory, getRechargingInventory, sortRechargingInventoryItems, setRechargingInventoryColSearchStr, addRechargingInventoryFilter, removeRechargingInventoryFilter, saveRechargingInventoryCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.rechargingInventory.rechargingInventoryItems.Columns;
        const { FirstFilter, SecondFilter, ThirdFilter, TotalFilter } = this.props?.rechargingInventory?.rechargingInventoryItems.StatusFilter || {};
        const statusData = [
                    { "label": DASHBOARD_LABEL.total, "value": TotalFilter ?? 0},
                    { "label": DASHBOARD_LABEL.mapped, "value": FirstFilter ?? 0 },
                    { "label": DASHBOARD_LABEL.unmapped, "value": SecondFilter ?? 0 },
                    { "label": DASHBOARD_LABEL.mismatched, "value": ThirdFilter ?? 0 }
                ];
        
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRW])

        const BUTTON_MENU = [
            {id: 1, label: 'Circuit', onClick: () => this.handleCreateNewAction(1)},
            {id: 2, label: 'Equipment', onClick: () => this.handleCreateNewAction(2)},
            {id: 3, label: 'OTC', onClick: () => this.handleCreateNewAction(3)}
        ] 
        
                         
        return(
            <div className="recharging-inventory-container dispute-container invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={this.state.showConfirmationModal}
                    message={this.state.confirmationModal.messageBody}
                    title={this.state.confirmationModal.title}
                    handleModal={!this.state.isMapInventory ? this.handleCreateNew.bind(this) : this.handleMapInventory.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <NotificationModal
                    show={this.state.showNotificationModal}
                    title={this.state.notificationModal.title}
                    message={this.state.notificationModal.message}
                    handleModal={() => this.handleMapInventory(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                /> 
                <RequestHeaders headerTitle={this.state.headerTitle} />                
                <div className="request-table data-table fit-width">
                    {
                        this.state.viewDetailPage ?
                        <>
                            {this.state.selectedDetailsView === 1 &&  <RechargingCircuitDetailsView rechargeInventoryId={this.state.rechargeInventoryId} closeFormAction={this.handleCloseDetailsPage} isCreateNew={this.state.isCreateNew}/>}
                            {this.state.selectedDetailsView === 2 && <RechargingEquipmentDetailsView rechargeInventoryId={this.state.rechargeInventoryId} closeFormAction={this.handleCloseDetailsPage} isCreateNew={this.state.isCreateNew}/>}
                            {this.state.selectedDetailsView === 3 &&  <RechargingOtcDetailsView rechargeInventoryId={this.state.rechargeInventoryId} closeFormAction={this.handleCloseDetailsPage} isCreateNew={this.state.isCreateNew}/>}

                        </>
                        :
                        <>
                            <DetailsDashboard
                            // Filter Properties
                            data={rechargingInventory.rechargingInventoryItems.TableFilterData}
                            translation={""}
                            addAction={addRechargingInventoryFilter}
                            removeAction={removeRechargingInventoryFilter}
                            applyAction={this.applyFilter}
                            isRefreshTable={!rechargingInventory.isRechargingInventoryLoaded}
                            //CreateNew Action
                            createNewAction={this.handleCreateNewAction}
                            buttonMenu={BUTTON_MENU}
                            hasAdditionalBtn={isReadAndWrite ? true : false}
                            mapInventoryAction={this.handleMapInventoryAction}

                            //View Search Textbox
                            viewSearchAction={this.DisplaySearhBox}

                            //Tab Selected
                            tabSelectedAction={this.state.contentIndex}

                            //Customize Column
                            firstList={Available}
                            secondList={Selected}
                            defaultList={Default}
                            saveAction={saveRechargingInventoryCustomCols}

                            //Extract Button
                            extractAction={(e) => this.onClickExtract(e)}

                            //StatusBar
                            statusData={statusData}
                            activeStatusFilter = {this.statusActiveFilter}

                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                        >
                            <DetailContainer
                                renderTabContent={this.handleSelectedIndex}
                                urlIndex={this.state.activeTab}
                                isMultiContainer={true}
                                listTab={[
                                    {
                                        "id": Selected_Index.i_Zero,
                                        "label": "All Recharging Inventory",
                                        "hidden": false
                                    },
                                    {
                                        "id": Selected_Index.i_One,
                                        "label": "Circuit",
                                        "hidden": false,
                                        "disable": false
                                    },
                                    {
                                        "id": Selected_Index.i_Two,
                                        "label": "Equipment",
                                        "hidden": false,
                                        "disable": false
                                    },
                                    {
                                        "id": Selected_Index.i_Three,
                                        "label": "OTC",
                                        "hidden": false,
                                        "disable": false
                                    },

                                ]}
                            >
                                <>
                                    {
                                        rechargingInventory.isRechargingInventoryLoaded ?
                                    <TablePagination  
                                        key={TABLE_PAGINATION_KEY.rechargingInventory}  
                                        classNameWrapper="overflow-auto" 
                                        columns={rechargingInventory.rechargingInventoryItems.Headers}
                                        pageList={rechargingInventory.rechargingInventoryItems.Data}
                                        pages={rechargingInventory.rechargingInventoryItems.Pagination}
                                        rowClickAction={(item) => {this.handleRowClick(item)}}
                                        paginationAction={getRechargingInventory}
                                        onColumnClick={sortRechargingInventoryItems}
                                        onColumnSearch={() => getRechargingInventory(0)} 
                                        onColumnSearchChange={setRechargingInventoryColSearchStr}
                                        isColSearchShow={this.state.displaySearch}
                                        resizePage={this.resizePage}
                                        totalPage={rechargingInventory.rechargingInventoryItems.Pagination.TotalEntries}
                                        hideStatusIcon={true}
                                    />
                                    : this.loading()}
                                </>
                            </DetailContainer>
                        </DetailsDashboard>  

                                                              
                    </>
                    }
                   
                </div>                
            </div>
        )
    }
}

 
export default withRouter(connect(
    state => {
            const { rechargingInventory, rechargeInventoryDetails,
                    form:{ forms:{ rechargeInventoryDetailsForm:{ $form } } }
             } = state;
            const { rechargeInventoryDetailsForm } = state.form;
            return {
                rechargingInventory
                , rechargeInventoryDetailsForm
                , rechargeInventoryDetails
                , translation
                , $form
            };
        },
    dispatch => bindActionCreators(
        Object.assign({}, rechargingInventoryActions, filterActions, RechargeInventoryDetailsActions),
        dispatch
    )
)(RechargingInventory));